import { IoPersonOutline } from "react-icons/io5";

const CompanyName = ({
  id,
  name,
  placeholder,
  type = "text",
  icon,
  required,
  action,
  ref,
}) => {
  return (
    <div className="flex items-center border bg-white rounded-lg p-2 w-80  mt-4">
      {/* Icon on the left */}
      {icon}
      {/* Input field */}
      <input
        type={type}
        id={id}
        ref={ref}
        name={name}
        required={required}
        placeholder={placeholder}
        className="flex-1 outline-none bg-white "
        onChange={action}
      />
    </div>
  );
};

export default CompanyName;
